module.exports = {
  "id": "understory tutorial 3",
  "startingScene": 0,
  "title": "3: Levels",
  "thumbnail": "/provision/projects/understory tutorial 3/tutorial 3 image.png",
  "category": "tutorial",
  "toolbar": {
    "glitches": [],
    "parts": []
  },
  "project_file": "understory tutorial 3.gbp",
  "tutorial_scripts": [
    "level1.json",
    "level2.json",
    "level3.json"
  ]
}
;